<template>
  <li
    v-if="filter.length > 0"
    class="single-filter"
    @mouseover="open = true"
    @mouseleave="open = false"
  >
    <div class="single-filter__title">
      {{ title === "Altitude Range" ? "Altitude" : title }}
      <div
        class="gd-searh__num"
        v-if="selected[title]?.length > 0 && title !== 'Altitude'"
      >
        <span>{{ selected[title]?.length }}</span>
      </div>
    </div>

    <transition name="slide-up-fade" mode="out-in">
      <div v-if="open" class="single-filter__list-wrap">
        <ul v-if="title !== 'Altitude'" class="single-filter__list">
          <li
            class="single-filter__list-item"
            v-for="(item, i) in filter"
            :key="i"
            @click="filterProducts([title, item.name])"
          >
            <input
              type="checkbox"
              :checked="selected[title].includes(item.name)"
            /><label>{{ item.name }}({{ getTotal(title, item.name)}})</label>
          </li>
        </ul>
        <div v-else class="single-filter__list single-filter__list--altitude">
          <Slider
            :min="+filter[0].name"
            :step="+10"
            :max="+filter[filter.length - 1].name"
            v-model="slider"
          />
          <div class="mob-filters__list-item-wrap">
            <p class="mob-filters__list-item text-left">
              <label>Altitude: {{ slider[0] }}m </label>
            </p>
            <p class="mob-filters__list-item text-right">
              <label>Altitude: {{ slider[1] }}m </label>
            </p>
            <div @click="applay" class="filters__clear activeClass">Apply</div>
          </div>
        </div>
      </div>
    </transition>
  </li>
</template>

<script>
import filterMixin from "../../mixins/filter";
export default {
  name: "SingleFilter",
  mixins: [filterMixin],
};
</script>
